import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as oidc } from 'redux-oidc';
import { loadingBarReducer } from 'react-redux-loading-bar';

import wizard from './reducers/wizard';
import device from './reducers/device';
import management from './reducers/management';
import user from './reducers/user';

export default combineReducers({
  form: reduxFormReducer,
  routing,
  oidc,
  loadingBar: loadingBarReducer,
  wizard,
  device,
  management,
  user,
});
